import React from "react";
import face from "../../Data/Images/salmanprottoy.jpg";
import { description } from "../../Data/Data";

const About = () => {
  return (
    <section className="about" id="About">
      <h2 className="about__title">About me</h2>
      <div className="about__data">
        <div className="about__info">
          {description.map((para) => (
            <p>{para}</p>
          ))}
        </div>
        <div className="about__image">
          <div className="wrapper">
            <div className="image__container">
              <div className="image__bg"></div>
              <img src={face} alt="Salman Prottoy" className="image" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
